<template>
  <div>
    <el-col>
      <h2>Modelo de contrato Empresa</h2>
      <iframe width="100%" height="350px" :src="uri"></iframe>
    </el-col>
    <el-col>
      <h2>Modelo de contrato persona fisica</h2>
      <iframe width="100%" height="350px" :src="uri2"></iframe>
    </el-col>
  </div>
</template>

<script>
//import ComponentInWorker from "@/components/ComponentInWorker";
export default {
  name: "trainingMview",
  data() {
    return {
      uri: "https://apicloud.magycorp.com:48028/docs/MAGYTRACK/MODELO%20CONTRATO%20MAGYTRACK%20%20EMPRESA.pdf",
      uri2: "https://apicloud.magycorp.com:48028/docs/MAGYTRACK/MODELO%20CONTRATO%20MAGYTRACK%20PERSONA%20FISICA%20CON%20DEPOSITO%20DE%20GARANTIA.pdf"
    };
  }
};
</script>

<style></style>
